module.exports = ".pc1 .col-md-2{\r\n    padding: 0px;\r\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/pigmy-creation/pigmy-creation.component.css
// module id = ./src/app/accountmaster/pigmy-creation/pigmy-creation.component.css
// module chunks = main